var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomersSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1047_38109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.68579C14.2523 9.68579 16.0781 7.85995 16.0781 5.60767C16.0781 3.35538 14.2523 1.52954 12 1.52954C9.74771 1.52954 7.92188 3.35538 7.92188 5.60767C7.92188 7.85995 9.74771 9.68579 12 9.68579Z",
    fill: "#FB607F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 9.68579C21.6739 9.68579 22.8281 8.53153 22.8281 7.10767C22.8281 5.68381 21.6739 4.52954 20.25 4.52954C18.8261 4.52954 17.6719 5.68381 17.6719 7.10767C17.6719 8.53153 18.8261 9.68579 20.25 9.68579Z",
    fill: "#FB607F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.68579C5.17386 9.68579 6.32812 8.53153 6.32812 7.10767C6.32812 5.68381 5.17386 4.52954 3.75 4.52954C2.32614 4.52954 1.17188 5.68381 1.17188 7.10767C1.17188 8.53153 2.32614 9.68579 3.75 9.68579Z",
    fill: "#FB607F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29016 12.0009C5.27531 11.1694 4.35623 11.2795 3.18281 11.2795C1.42781 11.2795 0 12.6989 0 14.4431V19.5623C0 20.3198 0.618281 20.9357 1.37859 20.9357C4.66106 20.9357 4.26562 20.9951 4.26562 20.7942C4.26562 17.1667 3.83597 14.5065 6.29016 12.0009Z",
    fill: "#FB607F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1161 11.2982C11.0665 11.1273 9.28506 11.3002 7.74845 12.5685C5.17703 14.6282 5.67189 17.4015 5.67189 20.7942C5.67189 21.6918 6.4022 22.4357 7.31345 22.4357C17.2079 22.4357 17.6017 22.7549 18.1885 21.4556C18.3809 21.0162 18.3281 21.1558 18.3281 16.9523C18.3281 13.6136 15.4372 11.2982 13.1161 11.2982Z",
    fill: "#FB607F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8172 11.2796C19.6373 11.2796 18.7233 11.1707 17.7098 12.001C20.1457 14.488 19.7344 16.9667 19.7344 20.7943C19.7344 20.9965 19.4061 20.9359 22.5722 20.9359C23.3597 20.9359 24 20.2979 24 19.5137V14.4432C24 12.699 22.5722 11.2796 20.8172 11.2796Z",
    fill: "#FB607F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1047_38109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersSelected);
export default __webpack_public_path__ + "static/media/customers_selected.9f9331adf427bdef7e16d2b07e884f05.svg";
export { ForwardRef as ReactComponent };